import {Button} from '@dropbox/dig-components/buttons';
import {Menu} from '@dropbox/dig-components/menu';
import {t} from 'i18next';

export type SendNowNotificationType = 'generic' | 'readiness_attention';

export const SendNowMenu = ({
  canSendReadiness,
  onSelect,
}: {
  canSendReadiness: boolean;
  onSelect: (type: SendNowNotificationType) => void;
}) => (
  <Menu.Wrapper>
    {({getContentProps, getTriggerProps}) => (
      <>
        <Button variant="filled" withDropdownIcon {...getTriggerProps()}>
          {t('send_now')}
        </Button>
        <Menu.Content {...getContentProps()} placement="bottom-end" minWidth="260px">
          <Menu.Segment>
            <Menu.ActionItem onClick={() => onSelect('generic')}>{t('generic')}</Menu.ActionItem>
            {canSendReadiness ? (
              <Menu.ActionItem onClick={() => onSelect('readiness_attention')}>
                {t('readiness_attention_notification')}
              </Menu.ActionItem>
            ) : null}
          </Menu.Segment>
        </Menu.Content>
      </>
    )}
  </Menu.Wrapper>
);
